import { DeliveryInformation, OrderTypes, ProductSupplement, SiloDistributionTypes } from '@next/core-lib/cart';

export interface DateRange {
  description?: string;
  startDate: Date;
  endDate: Date;
}

export interface OrderWrapper {
  orders: Order[];
}

export interface Order {
  id: number;
  createdOn: string;
  numberOfProducts?: number;
  orderNumbers: string[];
  orderStatus: OrderStatus;
  webOrderNumber: string;
  orderType: OrderTypes;
}

export interface OrderDetails extends Order {
  orderLines: OrderLine[];
  generalErrorMessages: string[];
}

export interface OrderLine {
  id: number;
  sku: Sku;
  skuDetail: SkuDetail;
  remarks?: string;
  orderQuantity: number;
  orderUnit: string;
  deliveryInformation: DeliveryInformation;
  silos: OrderSilo[];
  processedTimestamp: string;
  productSupplements: ProductSupplement[];
  orderLineStatus: OrderLineStatus;
  externalOrderId?: string;
  errorResults: ErrorResult[];
  externalInvoiceId: string;
}

export interface Sku {
  id: number;
  source?: string;
}

export interface SkuDetail extends Sku {
  externalId: string;
  productId: number;
  title?: string;
  description?: string;
  sellable: boolean;
  unit?: string;
  unitQuantity: number;
}

export interface OrderSilo {
  id: number;
  siloNumber: string;
  name: string;
  orderQuantity?: number;
  distributionType: SiloDistributionTypes;
}

export interface ErrorResult {
  message: string;
  messageId: string;
}

export enum OrderStatus {
  Processing = 'Processing',
  Finalized = 'Finalized',
  Error = 'Error',
}

export enum OrderLineStatus {
  Processing = 'Processing',
  Finalized = 'Finalized',
  NotProcessed = 'NotProcessed',
  Error = 'Error',
}

export enum OrderColumnTypes {
  orderNumbers = 'orderNumbers',
  webOrderNumber = 'webOrderNumber',
  numberOfProducts = 'numberOfProducts',
  createdOn = 'createdOn',
  orderStatus = 'orderStatus',
  orderType = 'orderType',
}

export enum OrderDetailsColumnTypes {
  orderNumbers = 'orderNumbers',
  name = 'name',
  nameMobile = 'nameMobile',
  deliveryDate = 'deliveryDate',
  orderQuantity = 'orderQuantity',
  externalInvoiceId = 'externalInvoiceId',
  silos = 'silos',
  supplements = 'supplements',
}

export interface OrderFilterValues {
  range: DateRange;
  search: string;
  status: OrderStatus[];
  orderType: OrderTypes[];
}
